import { render, staticRenderFns } from "./PaymentBlocked.vue?vue&type=template&id=6a86144b&scoped=true&"
import script from "./PaymentBlocked.vue?vue&type=script&lang=js&"
export * from "./PaymentBlocked.vue?vue&type=script&lang=js&"
import style0 from "./PaymentBlocked.vue?vue&type=style&index=0&id=6a86144b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a86144b",
  null
  
)

export default component.exports